import { Component } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import { Card, IconButton } from "@mui/material"
import { Delete } from "@mui/icons-material"
import "./styles.scss"
import classNames from "classnames"

export default class SmartTradePanel extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    removable: PropTypes.bool,
    onRemove: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = { hover: false }
  }

  toggleHover = (hoverIndex) => {
    this.setState({ hover: hoverIndex })
  }

  render() {
    const { items, removable, onRemove } = this.props
    const { hover } = this.state

    return <div className="panel">
      <Card square className="panel-wrapper">
        {map(items, ({ label, value }, index) => <div key={index} className={classNames("panel-row", { removable })} onMouseEnter={() => this.toggleHover(index)} onMouseLeave={() => this.toggleHover(false)}>
          <div className={classNames("panel-row-wrapper", { "remove-active": hover === index && removable })}>
            <div className="row-label">{label}</div>
            <div className="value-wrapper">
              {value}
              {removable && hover === index && <IconButton
                disabled={index === 0}
                className="delete-button"
                onClick={() => onRemove(index)}
                size="large"
              >
                <Delete />
              </IconButton>}
            </div>
          </div>
        </div>)}
      </Card>
    </div>
  }
}
